import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ButtonM, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import bg from "../../styles/images/img_find.png";
import bird from "../../styles/images/bird.svg";
import { authActions } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";

const FindComponent = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname;
  // console.log("path", path);
  const urls = process.env.REACT_APP_BASE_URL;

  return (
    <>
      <ImgWrap>
        <img src={bg} alt="" />

        <ButtonM
          onClick={() => {
            // dispatch(authActions.checkPagePathname(path));

            sessionStorage.setItem(
              "page",
              JSON.stringify({ path: path, option: "" })
            );

            window.open(`${urls}/danal/ready`, "_self", "fullscreen=yes");
          }}
        >
          휴대폰 인증 회원
        </ButtonM>
      </ImgWrap>
    </>
  );
};

export default FindComponent;

const ImgWrap = styled.div`
  margin-top: 8.4rem;
  text-align: center;
  img {
    width: 23.6rem;
  }
  button {
    margin-top: 2.6rem;
    position: relative;
    &::after {
      display: block;
      content: "";
      background-image: url(${bird});
      background-size: cover;
      background-position: center;
      width: 4.3rem;
      height: 4.9rem;
      position: absolute;
      top: -4.4rem;
      left: 2.3rem;
    }
  }
  @media screen and (min-width: 400px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const DescTextDiv = styled(TextDiv)`
  margin-top: 5.6rem;
  letter-spacing: -0.42px;
  a {
    font-family: NanumSquareB;
  }
`;
